import Explore from './Explore'

export default Explore